const isObjectLike = (value: unknown): value is Record<string, unknown> => typeof value === 'object' && value !== null;

const toId = (value: unknown): string | undefined => {
  if (typeof value === 'string') return value;
  if (!isObjectLike(value)) return undefined;
  if (typeof value._id === 'string') return value._id;
  if (typeof value.id === 'string') return value.id;
  return undefined;
};

const toName = (value: unknown): string | undefined => {
  if (typeof value === 'string') return value;
  if (!isObjectLike(value)) return undefined;
  if (typeof value.name === 'string') return value.name;
  return undefined;
};

const toOptionalString = (value: unknown): string | undefined => {
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean') return String(value);
  return undefined;
};

const KNOWN_FIELDS = new Set(['name', 'unit', 'units', 'email', 'phone', 'notes', 'language', 'gender', 'archived']);

export const normalizeExpertPayload = (input: Record<string, unknown>) => {
  const name = toName(input.name);
  const unit = toId(input.unit);
  const units = Array.isArray(input.units) ? input.units.map(toId).filter(Boolean) : undefined;
  const email = toOptionalString(input.email);
  const phone = toOptionalString(input.phone);
  const notes = toOptionalString(input.notes);
  const language = toName(input.language);
  const gender = toName(input.gender);
  const archived = typeof input.archived === 'boolean' ? input.archived : undefined;

  const normalized: Record<string, unknown> = {};
  if (name !== undefined) normalized.name = name;
  if (unit !== undefined) normalized.unit = unit;
  if (units !== undefined) normalized.units = units;
  if (email !== undefined) normalized.email = email;
  if (phone !== undefined) normalized.phone = phone;
  if (notes !== undefined) normalized.notes = notes;
  if (language !== undefined) normalized.language = language;
  if (gender !== undefined) normalized.gender = gender;
  if (archived !== undefined) normalized.archived = archived;

  for (const [key, value] of Object.entries(input)) {
    if (KNOWN_FIELDS.has(key)) continue;
    const normalizedValue = toOptionalString(value);
    if (normalizedValue !== undefined) {
      normalized[key] = normalizedValue;
    }
  }

  return normalized;
};

export const normalizeExpertId = (value: unknown): string | undefined => toId(value);

export const normalizeExpertQueryParams = (input: { name?: unknown; unit?: unknown }) => ({
  name: toName(input.name),
  unit: toId(input.unit),
});
